import React, {useRef, useEffect, useState} from 'react'
import classNames from 'classnames'
import style from './index.module.less'
import useBigScreen from "@/hooks/bigScreen"
import NewFooterList from './NewFooterList'
import NewFooterListMobile from './NewFooterListMobile'
import SocialMedia from './SocialMedia'
import PrivacyGlobal from './PrivacyGlobal'
import Email from './Email'
import { home_video2 } from "@/images/home/index"


const NewFooter = ({gtmEventModule, gtmEventName, gtmBtnType, footerfixed, onFooterReady = null}) => {
  const footerRef = useRef(null)
  const ifPc = useBigScreen(1000)
  const [footerZIndex, setFooterZIndex] = useState(false)

  useEffect(() => {
    if (footerRef.current && onFooterReady) {
      const height = footerRef.current.offsetHeight
      onFooterReady(height)
    }
  }, [])

  const changeFooterZIndex = (bool) => {
    setFooterZIndex(bool)
  }

  return (
    <div
      ref={footerRef}
      className={classNames(style.newfooter, footerfixed ? style.newfooterFixedBottom : "")} 
      style={{
        background: ifPc ? 'rgba(0, 0, 0, 0.6)' : 'rgba(0, 0, 0)',
        zIndex: footerZIndex ? 2002 : '',
      }}
    >
      {ifPc &&
        <video
          className={style.footerVideo}
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={home_video2} type="video/mp4" />
        </video>
      }
      {footerfixed && <div className={classNames(style.bgMaskBox)}></div>}

      <div className={style.footerTop}>
        <Email gtmEventModule={gtmEventModule} gtmEventName={gtmEventName} gtmBtnType={gtmBtnType}/>

        {ifPc ? <NewFooterList /> : <NewFooterListMobile />}
      </div>
      
      
      <div className={style.mediaPrivacy}>
        <SocialMedia />
        <PrivacyGlobal pChangeFooterZIndex={changeFooterZIndex}/>
      </div>
      
      
    </div>
  )
}

export default NewFooter
